<template>
  <div>
    <el-table :data="dataForTable" height="350" style="width: 100%;margin-left:-20px;">
      <el-table-column :prop="prop1" :label="label1" width="200"></el-table-column>
      <el-table-column :prop="prop2" :label="label2" width="200"></el-table-column>
      <el-table-column :prop="prop3" :label="label3" width="200"></el-table-column>
      <el-table-column :prop="prop4" :label="label4" width="200"></el-table-column>
    <el-table-column :prop="prop5" :label="label5" width="200"></el-table-column>
      <el-table-column :prop="prop6" :label="label6" width="200"></el-table-column>
      <el-table-column
      label="操作"
      width="120">
      <template slot-scope="scope">
        <el-button
          @click.native.prevent="deleteRow(scope.$index, dataForTable)"
          type="text"
          size="small">
          移除
        </el-button>
      </template>
    </el-table-column>
    </el-table>
  </div>
</template>

<script type="text/javascript" scoped>
import $ from 'jquery'
export default {
  props: ['prop1', 'prop2', 'label1', 'label2', 'prop3', 'label3', 'prop4', 'label4', 'prop5', 'label5', 'prop6', 'label6', 'dataForTable'],
  data () {
    return {
    }
  },
  methods: {
    deleteRow (index, rows) {
      const vm = this
      vm.$confirm('确认将会永久删除此条订单记录，是否确认？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'}).then(() => {
          $.ajax({
            type: 'POST',
            url: '/v1/userMessage/deleteTrade',
            data: {tradeNo: rows[index].tradeNo},
            dataType: 'json',
            success: function () {
              rows.splice(index, 1)
            },
            error: function () {
              vm.$message.error('删除失败，请稍后重试！')
            }
          })
        })
    }
  }
}
</script>
